import React, { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';

import SumIcon from '@/shared/assets/icons/sum.svg?react';

import { useGetCurrentMonthIcon } from '../../../../hooks/useGetCurrentMonthIcon';
import { sessionsStyles } from './style';

export const CustomMuiSessionsPerMonth = memo(
  ({ isSum = true, sum, isMonthSum = true, monthSum }) => {
    const { container } = sessionsStyles;
    const MonthIcon = useGetCurrentMonthIcon();

    return (
      <Box sx={container}>
        {isSum && (
          <Box className='item sum'>
            <SumIcon />
            {sum}
          </Box>
        )}
        {isMonthSum && (
          <Box className='item months'>
            {MonthIcon} {monthSum}
          </Box>
        )}
      </Box>
    );
  },
);
